import { useEffect, useMemo } from "react";
import L from "leaflet";
import { debounce } from "lodash";
import { useMapEvents } from "react-leaflet";
import { MapBounds } from "../../../../features/results/ResultsOperationalUnits/useOperationalUnitsData";

export const MapEvents = ({
	isProgrammaticMove,
	setCurrentZoom,
	lastUserZoomAt,
	onBoundsChange,
}: {
	isProgrammaticMove: React.RefObject<boolean>;
	setCurrentZoom: (zoom: number) => void;
	lastUserZoomAt: React.RefObject<number | null>;
	onBoundsChange?: (b: MapBounds) => void;
}) => {
	const handleMapChange = useMemo(
		() =>
			debounce((map: L.Map) => {
				if (isProgrammaticMove.current) {
					isProgrammaticMove.current = false;
					return;
				}

				const bounds = map.getBounds();
				const zoom = map.getZoom();
				setCurrentZoom(zoom);
				lastUserZoomAt.current = Date.now(); // remember when user zoomed

				onBoundsChange?.({
					max_lat: bounds.getNorth(),
					min_lat: bounds.getSouth(),
					max_lon: bounds.getEast(),
					min_lon: bounds.getWest(),
					zoom,
				});
			}, 300),
		[onBoundsChange]
	);

	useEffect(() => () => (handleMapChange as any)?.cancel?.(), [handleMapChange]);

	useMapEvents({
		moveend: (e) => handleMapChange(e.target),
		zoomend: (e) => handleMapChange(e.target),
	});

	return null;
};
